var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6709 16.7566C6.6709 14.4126 8.57105 12.5125 10.915 12.5125H25.3717C27.7157 12.5125 29.6158 14.4126 29.6158 16.7566C29.6158 19.1005 27.7157 21.0007 25.3717 21.0007H10.915C8.57105 21.0007 6.6709 19.1005 6.6709 16.7566Z",
    fill: "#FF6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7026 27.6828C17.7026 25.3389 19.6028 23.4387 21.9468 23.4387H33.756C36.0999 23.4387 38.0001 25.3389 38.0001 27.6828C38.0001 30.0268 36.0999 31.927 33.756 31.927H21.9468C19.6028 31.927 17.7026 30.0268 17.7026 27.6828Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1123 27.6828C7.1123 25.3389 9.01246 23.4387 11.3564 23.4387H11.6932C14.0371 23.4387 15.9373 25.3389 15.9373 27.6828C15.9373 30.0268 14.0371 31.927 11.6932 31.927H11.3564C9.01246 31.927 7.1123 30.0268 7.1123 27.6828Z",
    fill: "#FF6262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoHeader);
export default __webpack_public_path__ + "static/media/img_logo_header.ee754e1c258d02768177888d0be6fa5f.svg";
export { ForwardRef as ReactComponent };